export default defineNuxtRouteMiddleware((to, from) => {
	// console.log("herehrehs")
	const router = useRouter()
	const LangsStore = useLangsStore()
	if (to.path === "/") router.replace({ path: "/" + LangsStore.context.lang_id })
})
